import { AuthUserState } from "../../Types/Types";
import { AuthActionTypes, AuthActions } from "./types";


const initialState: AuthUserState = {
    isAuth: false,
    userAuthPayload: null
}

export const authReducer = (state = initialState, action: AuthActions): AuthUserState => {
    switch (action.type) {
        case AuthActionTypes.LOGIN:
            return { isAuth: true, userAuthPayload: action.payload }
        case AuthActionTypes.LOGOUT:
            return { isAuth: false, userAuthPayload: null }
        default:
            return state;
    }
}
